import { Button } from '@/components/ui/button';
import { useClientTranslation } from '@/lib/core/i18n';

export interface FilterBottomBarProps {
  /** Number of filters currently selected in the draft state. */
  selectedCount: number;
  onShowResults: () => void;
  onRemoveAll: () => void;
  /** The last applied draft returned zero products — disables the button and swaps its label. */
  noResults?: boolean;
  /** A show-results apply is in flight — disables the button to prevent duplicate submits. */
  pending?: boolean;
}

export function FilterBottomBar({
  selectedCount,
  onShowResults,
  onRemoveAll,
  noResults,
  pending,
}: FilterBottomBarProps) {
  const t = useClientTranslation();
  const hasSelection = selectedCount > 0;

  return (
    <div className="border-jncquoi-neutral-400 flex shrink-0 flex-col gap-1 border-t-[0.5px] px-4 pt-4 pb-10.5">
      <Button
        variant={hasSelection ? 'primary-solid' : 'secondary-outline'}
        size="md"
        onClick={onShowResults}
        disabled={noResults || pending}
        className="w-full"
      >
        {pending
          ? t('App.Labels.Loading')
          : noResults
            ? t('App.Shop.Filter.NoResultsFound')
            : t('App.Shop.Filter.ShowResults')}
      </Button>
      <Button
        variant="tertiary-link"
        size="sm"
        onClick={onRemoveAll}
        disabled={!hasSelection}
        className="w-full"
      >
        {hasSelection
          ? t('App.Shop.Filter.RemoveFiltersCount', { count: selectedCount })
          : t('App.Shop.Filter.RemoveFilters')}
      </Button>
    </div>
  );
}
